import React from "react"
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  alpha,
  useTheme,
} from "@mui/material"
import { useTranslation } from "react-i18next"

const RestaurantsExamplesSection = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  const restaurants = [
  
    {
      id: 2,
      name: "Cafe Cafe",
      description: t("Israeli street food"),
      logo: "/images/startPage/caf.png",
      isImage: true,
      url: "https://qrseller-client.netlify.app/?restaurant_id=2",
    },
      {
      id: 91,
      name: "Ashis",
      description: t("A chain of Café- restaurants"),
      logo: "/images/startPage/as.jpg",
      isImage: true,
      url: "https://qrseller-client.netlify.app/?restaurant_id=91",
    },
  ]

  const handleRestaurantClick = (url) => {
    window.open(url, "_blank")
  }

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: alpha(theme.palette.primary.main, 0.02),
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="overline"
            sx={{
              color: "primary.main",
              fontWeight: 600,
              letterSpacing: "0.1em",
              fontSize: "0.875rem",
            }}
          >
            {t("SUCCESS STORIES")}
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "3rem" },
              fontWeight: 700,
              mt: 1,
              mb: 2,
              color: "text.primary",
            }}
          >
            {t("Our Clients")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.125rem",
              color: "text.secondary",
              maxWidth: "700px",
              mx: "auto",
            }}
          >
            {t("See how businesses like yours are thriving with QRseller")}
          </Typography>
        </Box>

        {/* Restaurants Grid */}
        <Grid
            container
            spacing={4}
            justifyContent="center"
            sx={{
              px: { xs: 2, sm: 4, md: 6 },
            }}
          >
            {restaurants.map((restaurant) => (
              <Grid item xs={12} sm={10} md={5} lg={4} key={restaurant.id}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "background.paper",
                    border: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: `0 12px 32px ${alpha(theme.palette.primary.main, 0.15)}`,
                      borderColor: alpha(theme.palette.primary.main, 0.3),
                    },
                  }}
                >
                  <CardActionArea
                    onClick={() => handleRestaurantClick(restaurant.url)}
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "stretch",
                    }}
                  >
                    {restaurant.isImage ? (
                      <CardMedia
                        component="img"
                        height="220"
                        image={restaurant.logo}
                        alt={restaurant.name}
                        sx={{
                          objectFit: "cover",
                          backgroundColor: alpha(theme.palette.grey[100], 0.5),
                        }}
                      />
                    ) : (
                      <CardMedia
                        sx={{
                          height: 220,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "80px",
                          backgroundColor: alpha(theme.palette.grey[100], 0.5),
                          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`,
                        }}
                      >
                        {restaurant.logo}
                      </CardMedia>
                    )}
                    <CardContent sx={{ flexGrow: 1, p: 3 }}>
                      <Typography
                        gutterBottom
                        variant="h6"
                        component="div"
                        align="center"
                        sx={{
                          fontWeight: 700,
                          color: "text.primary",
                          mb: 1.5,
                        }}
                      >
                        {restaurant.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        align="center"
                        sx={{
                          lineHeight: 1.7,
                        }}
                      >
                        {restaurant.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
      </Container>
    </Box>
  )
}

export default RestaurantsExamplesSection
